var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 6.8C4.66913 6.8 5.40675 6.49447 5.95061 5.95061C6.49447 5.40675 6.8 4.66913 6.8 3.9C6.8 3.13087 6.49447 2.39325 5.95061 1.84939C5.40675 1.30553 4.66913 1 3.9 1C3.13087 1 2.39325 1.30553 1.84939 1.84939C1.30553 2.39325 1 3.13087 1 3.9C1 4.66913 1.30553 5.40675 1.84939 5.95061C2.39325 6.49447 3.13087 6.8 3.9 6.8ZM5.35 28.55C6.50369 28.55 7.61013 28.0917 8.42591 27.2759C9.2417 26.4601 9.7 25.3537 9.7 24.2C9.7 23.0463 9.2417 21.9399 8.42591 21.1241C7.61013 20.3083 6.50369 19.85 5.35 19.85C4.19631 19.85 3.08987 20.3083 2.27409 21.1241C1.4583 21.9399 1 23.0463 1 24.2C1 25.3537 1.4583 26.4601 2.27409 27.2759C3.08987 28.0917 4.19631 28.55 5.35 28.55ZM25.65 30C26.8037 30 27.9101 29.5417 28.7259 28.7259C29.5417 27.9101 30 26.8037 30 25.65C30 24.4963 29.5417 23.3899 28.7259 22.5741C27.9101 21.7583 26.8037 21.3 25.65 21.3C24.4963 21.3 23.3899 21.7583 22.5741 22.5741C21.7583 23.3899 21.3 24.4963 21.3 25.65C21.3 26.8037 21.7583 27.9101 22.5741 28.7259C23.3899 29.5417 24.4963 30 25.65 30ZM14.05 18.4C15.5883 18.4 17.0635 17.7889 18.1512 16.7012C19.2389 15.6135 19.85 14.1383 19.85 12.6C19.85 11.0617 19.2389 9.58649 18.1512 8.49878C17.0635 7.41107 15.5883 6.8 14.05 6.8C12.5117 6.8 11.0365 7.41107 9.94878 8.49878C8.86107 9.58649 8.25 11.0617 8.25 12.6C8.25 14.1383 8.86107 15.6135 9.94878 16.7012C11.0365 17.7889 12.5117 18.4 14.05 18.4ZM22.75 6.8C23.5191 6.8 24.2568 6.49447 24.8006 5.95061C25.3445 5.40675 25.65 4.66913 25.65 3.9C25.65 3.13087 25.3445 2.39325 24.8006 1.84939C24.2568 1.30553 23.5191 1 22.75 1C21.9809 1 21.2432 1.30553 20.6994 1.84939C20.1555 2.39325 19.85 3.13087 19.85 3.9C19.85 4.66913 20.1555 5.40675 20.6994 5.95061C21.2432 6.49447 21.9809 6.8 22.75 6.8Z",
    stroke: "url(#paint0_linear_1714_4845)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07812 6.07471L8.97812 8.97471M19.8531 6.79971L18.4031 8.24971M22.7531 22.3872L18.4031 16.9497M8.25312 20.5747L11.1531 17.6747",
    stroke: "url(#paint1_linear_1714_4845)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_4845",
    x1: 1,
    y1: -2.625,
    x2: 31.9155,
    y2: 31.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1714_4845",
    x1: 6.07813,
    y1: 4.03564,
    x2: 23.4293,
    y2: 23.4625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr5);
export default __webpack_public_path__ + "static/media/Hr5.c354227bdc3354c7430205b71ea520f4.svg";
export { ForwardRef as ReactComponent };